"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var GroupWrapper_1 = __importDefault(require("./styledComponents/GroupWrapper"));
var GroupListWrapper_1 = __importDefault(require("./styledComponents/GroupListWrapper"));
var TitleWrapper_1 = __importDefault(require("./styledComponents/TitleWrapper"));
var Title_1 = __importDefault(require("./styledComponents/Title"));
var Subtitle_1 = __importDefault(require("./styledComponents/Subtitle"));
var Value_1 = __importDefault(require("./styledComponents/Value"));
var ValueText_1 = __importDefault(require("./styledComponents/ValueText"));
var ValuePlaceholder_1 = __importDefault(require("./styledComponents/ValuePlaceholder"));
var Tooltip_1 = __importDefault(require("../../base/Tooltip/Tooltip"));
var Image_1 = __importDefault(require("../../base/Image/Image"));
var Fact_meta_1 = require("./Fact.meta");
var mobx_1 = require("mobx");
var ChangeIndicator_1 = __importDefault(require("../../overview/ChangeIndicator/ChangeIndicator"));
var RiskRating_1 = __importDefault(require("../../risk/RiskRating/RiskRating"));
var MorningStar_1 = __importDefault(require("../../base/MorningStar/MorningStar"));
var DocumentTiles_1 = __importDefault(require("../../file/DocumentTiles"));
var Translate_1 = __importStar(require("../../base/Translate/Translate"));
var AsOfDate_1 = require("../../base/AsOfDate/AsOfDate");
var factHasValue_1 = require("../../../shared/factHasValue");
var List_1 = __importDefault(require("../../base/List"));
var Link_1 = __importDefault(require("../../base/Link"));
var formatter = ksys_app_template_1.utils.formatter.formatter;
var Fact = /** @class */ (function (_super) {
    __extends(Fact, _super);
    function Fact(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Fact_meta_1.FACT_CATEGORY_KEY;
        _this.componentKey = Fact_meta_1.FACT_COMPONENT_KEY;
        _this.getValueText = function (translationContext) {
            var _a = _this.props, format = _a.format, _b = _a.listValueSeparator, listValueSeparator = _b === void 0 ? ', ' : _b;
            var value = _this.props.value;
            if (Array.isArray(value)) {
                value = value.join(listValueSeparator);
            }
            if (format && value) {
                format.locale = format.locale || (translationContext && translationContext.culture);
                format.options = format.options || {};
                value = formatter(format, value);
            }
            return (react_1.default.createElement(ValueText_1.default, null, value));
        };
        return _this;
    }
    Fact_1 = Fact;
    Fact.prototype.tooltip = function (element) {
        var tooltip = this.props.tooltip;
        if (tooltip) {
            var tooltipProps = tooltip[element];
            return tooltipProps && react_1.default.createElement(Tooltip_1.default, __assign({}, tooltipProps));
        }
    };
    Object.defineProperty(Fact.prototype, "blankDataOptions", {
        get: function () {
            var _a = this.props.blankDataOptions, blankDataOptions = _a === void 0 ? {} : _a;
            var defaultBlankDataOptions = {
                showBlank: true,
                placeholder: 'N/A',
            };
            return Object.assign(defaultBlankDataOptions, blankDataOptions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "hasTitle", {
        get: function () {
            var _a = this.props, title = _a.title, subtitle = _a.subtitle;
            return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(title) || !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(subtitle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "hasValue", {
        get: function () {
            return factHasValue_1.factHasValue(this.props);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "title", {
        get: function () {
            var _a = this.props.title, title = _a === void 0 ? '' : _a;
            return (react_1.default.createElement(Title_1.default, null,
                react_1.default.createElement(Translate_1.default, null, title),
                this.tooltip('title')));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "subtitle", {
        get: function () {
            var _a = this.props.subtitle, subtitle = _a === void 0 ? '' : _a;
            return (react_1.default.createElement(Subtitle_1.default, null,
                typeof (subtitle) === 'string'
                    ? react_1.default.createElement(Translate_1.default, null, subtitle)
                    : react_1.default.createElement(AsOfDate_1.AsOfDate, __assign({}, subtitle)),
                this.tooltip('subtitle')));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "placeholder", {
        get: function () {
            var placeholder = this.blankDataOptions.placeholder;
            return (react_1.default.createElement(ValuePlaceholder_1.default, null,
                react_1.default.createElement(Translate_1.default, null, placeholder)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "changeIndicatorValue", {
        get: function () {
            var changeIndicatorProps = this.props.changeIndicatorProps;
            return (react_1.default.createElement(ChangeIndicator_1.default, __assign({}, changeIndicatorProps)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "riskRatingValue", {
        get: function () {
            var riskRatingProps = this.props.riskRatingProps;
            return (react_1.default.createElement(RiskRating_1.default, __assign({}, riskRatingProps)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "morningstarRatingValue", {
        get: function () {
            var morningstarRatingProps = this.props.morningstarRatingProps;
            return (react_1.default.createElement(MorningStar_1.default, __assign({}, morningstarRatingProps)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "link", {
        get: function () {
            var linkProps = this.props.linkProps;
            if (linkProps) {
                return (react_1.default.createElement(Link_1.default, __assign({}, linkProps)));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "appAsset", {
        get: function () {
            var appAssetProps = this.props.appAssetProps;
            return react_1.default.createElement(Image_1.default, __assign({}, appAssetProps));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "documentTilesValue", {
        get: function () {
            var _a = this.props, documentTilesProps = _a.documentTilesProps, onDocumentClick = _a.onDocumentClick;
            return (react_1.default.createElement(DocumentTiles_1.default, __assign({}, documentTilesProps, { onDocumentClick: onDocumentClick })));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "groupedListValue", {
        get: function () {
            var groupedListProps = this.props.groupedListProps;
            if (groupedListProps && groupedListProps.items && Array.isArray(groupedListProps.items)) {
                return (react_1.default.createElement(List_1.default, { items: (groupedListProps.items).map(function (fact) {
                        return react_1.default.createElement(Fact_1, __assign({}, fact));
                    }) }));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fact.prototype, "isGroupedList", {
        get: function () {
            var dataType = this.props.dataType;
            return dataType === 'grouped-list';
        },
        enumerable: true,
        configurable: true
    });
    Fact.prototype.getValue = function (translationContext) {
        var dataType = this.props.dataType;
        if (this.hasValue) {
            if (dataType === 'change-indicator') {
                return this.changeIndicatorValue;
            }
            if (dataType === 'risk-rating') {
                return this.riskRatingValue;
            }
        }
        if (dataType === 'morningstar-rating') {
            return this.morningstarRatingValue;
        }
        if (dataType === 'app-asset') {
            return this.appAsset;
        }
        if (dataType === 'document-tiles') {
            return this.documentTilesValue;
        }
        if (dataType === 'grouped-list') {
            return this.groupedListValue;
        }
        if (dataType === 'link') {
            return this.link;
        }
        return this.hasValue
            ? this.getValueText(translationContext)
            : this.placeholder;
    };
    Fact.prototype.renderValue = function (translationContext) {
        return (react_1.default.createElement(Value_1.default, { "data-has-title": this.hasTitle, "data-has-grouped-list": this.isGroupedList },
            this.getValue(translationContext),
            this.tooltip('value')));
    };
    Fact.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, hide = _a.hide;
        var showBlank = this.blankDataOptions.showBlank;
        if ((!this.hasValue && !showBlank) || hide) {
            return null;
        }
        var FactWrapper = this.isGroupedList ? GroupWrapper_1.default : react_1.Fragment;
        return (react_1.default.createElement(Wrapper_1.default, { className: className, role: "group" },
            react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
                return (react_1.default.createElement(FactWrapper, null,
                    _this.hasTitle &&
                        react_1.default.createElement(TitleWrapper_1.default, null,
                            _this.title,
                            _this.subtitle),
                    _this.isGroupedList &&
                        react_1.default.createElement(GroupListWrapper_1.default, null, _this.renderValue(translationContext)),
                    !_this.isGroupedList && _this.renderValue(translationContext)));
            })));
    };
    var Fact_1;
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "blankDataOptions", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "hasTitle", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "hasValue", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "title", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "subtitle", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "placeholder", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "changeIndicatorValue", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "riskRatingValue", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "morningstarRatingValue", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "link", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "appAsset", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "documentTilesValue", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "groupedListValue", null);
    __decorate([
        mobx_1.computed
    ], Fact.prototype, "isGroupedList", null);
    Fact = Fact_1 = __decorate([
        mobx_react_1.observer
    ], Fact);
    return Fact;
}(shared_1.ComponentBase));
exports.Fact = Fact;
exports.default = shared_1.InjectedStyledComponent(Fact, Fact_meta_1.FACT_CATEGORY_KEY, Fact_meta_1.FACT_COMPONENT_KEY);
